import type { ContentVersion } from "../utils/types"

export const useContentStore = defineStore("content", {
  state: (): {
    versions: Record<string, ContentVersion | undefined>
    currentVersionId: string | null
  } => ({
    versions: {},
    currentVersionId: null
  }),
  actions: {
    setContentVersion(
      contentVersionId: string,
      contentVersion: ContentVersion
    ): void {
      this.versions[contentVersionId] = contentVersion
      this.currentVersionId = contentVersionId
    }
  },
  getters: {
    currentVersion(): ContentVersion | undefined {
      if (this.currentVersionId) {
        return this.versions[this.currentVersionId]
      }
      return undefined
    }
  },
  persist: {
    storage: persistedState.localStorage
  }
})
